import { render, staticRenderFns } from "./giftrecord.vue?vue&type=template&id=3bfce989&scoped=true"
import script from "./giftrecord.vue?vue&type=script&lang=js"
export * from "./giftrecord.vue?vue&type=script&lang=js"
import style0 from "./giftrecord.vue?vue&type=style&index=0&id=3bfce989&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfce989",
  null
  
)

export default component.exports